import React, { useState } from 'react'
import style from './DentalContent.module.css'

const DentalSurgicalContent = ({ page }) => {
	const [showMoreInfo, setshowMoreInfo] = useState(false)
	return (
		<div className='mt-7 md:mt-14 leading-normal'>
			<div>
				<div
					className={style.detail}
					dangerouslySetInnerHTML={{
						__html: page?.content?.substring(0, showMoreInfo ? page?.content?.length : 975) + `${!showMoreInfo && page?.content?.length > 975 ? '...' : ''}`
					}}
				/>
			</div>
			<div>
				{!showMoreInfo && page?.content?.length > 1000 && (
					<button className='dark-blue-bg text-white py-3 px-7 rounded-full shadow-lg cursor-pointer w-max font-bold' onClick={() => setshowMoreInfo(true)}>
						Read More
					</button>
				)}
			</div>
		</div>
	)
}

export default DentalSurgicalContent
